import { InjectionToken } from "@angular/core";

export const FHIR_MIDDLEWARE_SERVICE_API_URL = new InjectionToken<string>(
    "FhirMiddlewareServiceApiUrl"
);

/**
 * URL segment used for root-subject endpoints.
 *
 * Hard-coded "patient" in the route means that the endpoint is for the entire patient and does not
 * support child subjects.
 */
export const ROOT_DATASET_API_PATH = "patient";
